const TRACK_CAR_AREA_PATTERN = /(?:^|_)(track_(\d+))_(car_(\d+))$/;

export interface TrackCarArea {
  trackNumber: number;
  carNumber: number;
  trackSegment: string;
  carSegment: string;
}

export const parseTrackCarArea = (area: string): TrackCarArea | undefined => {
  const match = TRACK_CAR_AREA_PATTERN.exec(area.trim().toLowerCase());
  if (match === null) {
    return undefined;
  }

  const [, trackSegment, track, carSegment, car] = match;
  const trackNumber = Number(track);
  const carNumber = Number(car);
  if (
    trackSegment === undefined ||
    carSegment === undefined ||
    !Number.isFinite(trackNumber) ||
    !Number.isFinite(carNumber)
  ) {
    return undefined;
  }

  return { trackNumber, carNumber, trackSegment, carSegment };
};

export const pickTrackCarColor = (
  colors: string[],
  oneBasedNumber: number
): string | undefined => {
  const zeroBased = oneBasedNumber - 1;
  return colors[((zeroBased % colors.length) + colors.length) % colors.length];
};
